exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subtask-title[data-v-468a78b0]{color:#303030;font-family:Open Sans,sans-serif;font-size:14px;letter-spacing:0;line-height:22px;font-weight:400}.icon-btn[data-v-468a78b0]{margin:0;padding:0;border:none;background:transparent;outline:none}", ""]);

// exports
